import Environment from "../../environment";

import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import ReCAPTCHA from "react-google-recaptcha";

import { UserService } from '../../services/UserService';
import useRequest from '../../hooks/useRequest';
import { isMobile } from '../../helpers/Mobile';

import SpinnerAbsa from 'components/atoms/SpinnerAbsa';
import LoginHeader from '../../components/atoms/LoginHeader';
import FooterMobile from '../../components/atoms/FooterMobile';
import InputText from '../../components/atoms/InputText';
import InputCheckbox from '../../components/atoms/InputCheckbox';
import ActionButton from '../../components/atoms/ActionButton';
import GradientButton from '../../components/atoms/GradientButton';
import Icon from '../../components/atoms/Icon';

import './styles.scss';

const RegisterView = (props) => {
    const history = useHistory();

    const recaptchaRef = React.createRef();
    const [token, setToken] = useState();

    const {
        submitted, success, message, errors,
        beforeSubmit, afterSubmit, showError,
        dealWithError
    } = useRequest();

    const [email, setEmail] = useState("");
    const [clave, setClave] = useState("");
    const [claveConfirmacion, setClaveConfirmacion] = useState("");
    const [showPass, setshowPass] = useState(false);
    const [terms, setTerms] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();
        const data = {
            email: email,
            password: clave,
            password_confirmation: claveConfirmacion,
            recaptcha_token: token
        }

        if (!terms){
            showError('Debe aceptar los términos y condiciones');
            return;
        }

        if(!token){
            showError('Debe confirmar que no es un robot');
            return;
        }

        UserService.register(data)
        .then(data => {
            afterSubmit();
            history.push('/cuenta_creada');
        }).catch((error) => {
            dealWithError(error, 'No se ha podido registrar');
        });
    }

    function captcha(value) {
        setToken(value);
    }

    const login = (e) => {
        e.preventDefault();
        history.push('/login');
    }

    return (
            <div className="register-container">
                <LoginHeader link="https://www.aguasbonaerenses.com.ar/"></LoginHeader>

                <div className="register-content">
                    <form className="register-form" onSubmit={handleSubmit}>
                        <h1 className="register-title">Registro de Usuario</h1>
                        <div className="register-input-group">
                            <div className="register-input-icon-container">
                                <Icon name="email" width={26} height={17} fill={isMobile ? '#1F3BA3' : '#1F3BA3'} />
                            </div>
                            <div className="register-input-container">
                                <InputText id="email" label="" placeholder="Ingresá tu e-mail"
                                    handleChange={(event) => { setEmail(event.target.value) }} error={errors.email}/>
                            </div>
                        </div>
                        <div className="register-input-group">
                            <div className="register-input-icon-container">
                                <Icon name="lock" width={26} height={17} fill={isMobile ? '#1F3BA3' : '#1F3BA3'} />
                            </div>
                            <div className="register-input-container">
                                <InputText id="password" label="" placeholder="Ingresá tu contraseña"
                                    handleChange={(event) => { setClave(event.target.value) }}
                                    type={showPass ? 'text' : 'password'} error={errors.password}/>
                                <div className={showPass ? 'register-eye show' : 'register-eye hide'} onClick={() => { setshowPass(false) }}>
                                    <Icon name="eye" width={26} height={17} fill={isMobile ? '#1F3BA3' : '#1F3BA3'} />
                                </div>
                                <div className={showPass ? 'register-eye-closed hide' : 'register-eye show'} onClick={() => { setshowPass(true) }}>
                                    <Icon name="eye-closed" width={26} height={17} fill={isMobile ? '#1F3BA3' : '#1F3BA3'} />
                                </div>
                            </div>
                        </div>
                        <div className="register-input-group">
                            <div className="register-input-icon-container">
                            <Icon name="lock" width={26} height={17} fill={isMobile ? '#1F3BA3' : '#1F3BA3'} />
                            </div>
                            <div className="register-input-container">
                                <InputText id="password_confirmation" label="" placeholder="Repetí tu contraseña"
                                    handleChange={(event) => { setClaveConfirmacion(event.target.value) }}
                                    type={showPass ? 'text' : 'password'} error={errors.password_confirmation}/>
                                <div className={showPass ? 'register-eye show' : 'register-eye hide'} onClick={() => { setshowPass(false) }}>
                                    <Icon name="eye" width={26} height={17} fill={isMobile ? '#1F3BA3' : '#1F3BA3'} />
                                </div>
                                <div className={showPass ? 'register-eye-closed hide' : 'register-eye show'} onClick={() => { setshowPass(true) }}>
                                    <Icon name="eye-closed" width={26} height={17} fill={isMobile ? '#1F3BA3' : '#1F3BA3'} />
                                </div>
                            </div>
                        </div>
                        <div className="register-captcha">
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={Environment.recaptchaSiteKey}
                            onChange={captcha}
                        />
                            {/* <img src={captcha} alt="Captcha TODAVIA SIN FUNCIONAR." /> */}
                        </div>
                        <div className="register-terms">
                        <InputCheckbox handleChange={() => { setTerms(!terms) }} legend={["Acepto los ", <a href={`${Environment.api}términos_y_condiciones.pdf`} target="_blank"> Términos y Condiciones </a>]} />
                        </div>
                        {(success === false && message) &&
                            <p className="error-messages">{message}</p>
                        }
                        <div className="register-button">
                            <GradientButton legend={'REGISTRARME'} disabled={submitted}
                                handleClick={handleSubmit} type={'submit'} />
                        </div>
                        <div className="register-bottom-content">
                            <p className="register-bottom-legend">¿Ya tenés cuenta?</p>
                            <div className="register-bottom-button">
                                <ActionButton legend="INGRESAR" handleClick={login} />
                            </div>
                        </div>
                    </form>
                </div>
                {isMobile && <FooterMobile></FooterMobile>}
                <SpinnerAbsa></SpinnerAbsa>
            </div>
    );
}

export default withTranslation()(RegisterView);